// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.6.287",
  "gitHash": "cfaccd2c20bba2b43fea529523042249c90b9a41",
  "versionWithHash": "5.6.287-cfaccd2c20bba2b43fea529523042249c90b9a41"
};
